<template>
  <div v-if="loading || !reportsBlank">
    <stats-bar class="m-5" :report="this.reports.summary.results" :stats="this.statBarStats" />
    <hr class="m-0 border-border my-5" />

    <b-row class="m-3">
      <b-col md="12">
        <h5>Value Through Session (placeholder)</h5>
            <b-row>
              <b-col md="6">
                <session-depth-stacked-bar-graph></session-depth-stacked-bar-graph>
              </b-col>
              <b-col md="6">
                <session-value-spline-graph></session-value-spline-graph>
              </b-col>
            </b-row>
      </b-col>
      <b-col md="6">
        <report-time-stat-graphs
          :report="reports.time.results"
          :stats="reports.time.stats"
          :fields="reports.time.fields"
          :interval="reports.time.interval"
          :joint-tooltip="true"
          :timezone="options.timezone">
        </report-time-stat-graphs>
      </b-col>
      <b-col md="6">
        <funnel-graph title="User Funnel" :data="funnelData" />
      </b-col>
    </b-row>
    <report-table
      :report="reports.table.results"
      :stats="reports.table.stats"
      :fields="reports.table.fields"
      :current-page="currentPage"
      :per-page="perPage"
      :synced-with-graph="true"
      @page-change="pageChange($event)"
      ref="table">
    </report-table>
    <hr class="m-0 border-border" />
    <b-pagination
      v-if="perPage > 0 && reports.table.results.length > 0"
      class="mt-3"
      :total-rows="reports.table.results.length"
      align="center"
      v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
  </div>
  <no-results v-else></no-results>
</template>

<script>
import StatsBar from '@/components/StatsBar'
import { ReportsApi } from '@/reports/api'
import ReportTable from '@/reports/components/ReportTable'
import FunnelGraph from '@/reports/components/graphs/FunnelGraph'
import ReportTimeStatGraphs from '@/reports/components/graphs/ReportTimeStatGraphs'
import { getSuggestedInterval, isExchangeView, getBasePublisherField } from '@/reports/components/ReportUtils'
import SessionValueSplineGraph from '@/reports/components/graphs/SessionValueSplineGraph'
import SessionDepthStackedBarGraph from '@/reports/components/graphs/SessionDepthStackedBarGraph'
import NoResults from '@/components/NoResults'

export default {
  name: 'UserOverview',
  props: {
    options: { type: Object, required: true }
  },
  data () {
    return {
      currentPage: 0,
      perPage: 10,
      statBarStats: ['uniques', 'auctions', 'bids', 'clears'],
      reports: {
        table: {
          results: [],
          stats: ['uniques', 'auctions', 'bids', 'clears'],
        },
        //summary report to fill out stats bar and funnel
        summary: {
          results: [],
          fields: ['exchange'],
          stats: ['uniques', 'auctions', 'bids', 'clears' ]
        },
        time: {
          results: [],
          interval: 'HOUR',
          stats: ['uniques'],
          dateAsMillis: true
        }
      },
      currentlyViewedReport: [],
      loading: false,
    }
  },
  created () {
    let baseField = getBasePublisherField(this)
    this.reports.table.fields = [baseField]
    this.reports.time.fields = [baseField]

    this.getInterval()
    this.fetchReports()
  },
  methods: {
    getInterval () {
      this.reports.time.interval = getSuggestedInterval(this.options.startTime, this.options.endTime)
    },
    pageChange (currentlyViewedReport) {
      this.currentlyViewedReport = currentlyViewedReport
    },
    fetchReport (name) {

      return ReportsApi.bqreport(this.getReportOptions(name), this).then((data) => {
        this.reports[name].results = data.results
      }, (e) => {
        console.error(e)
      })
    },
    fetchReports () {
      this.loading = true
      let promises = []
      for (let report in this.reports) {
        promises.push(this.fetchReport(report))
      }
      Promise.all(promises).then(() => {
        this.loading = false
      })
    },
    getReportOptions (name) {
      let options = JSON.parse(JSON.stringify(this.reports[name]))
      delete options.results
      return this.mergeOptions(options)
    },
    mergeOptions (options) {
      let mergedOptions = JSON.parse(JSON.stringify(this.options))
      for (let option in options) {
        mergedOptions[option] = options[option]
      }
      return mergedOptions
    }
  },
  computed: {
    reportsBlank () {
      for (let report in this.reports) {
        if (this.reports[report].results.length !== 0) {
          return false
        }
      }
      return true
    },
    funnelData () {
      if (this.reports.summary.results.length === 0) {
        return []
      } else {
        let data = this.reports.summary.results[0]
        return [
          { name: 'Auctions', number: Number(data.auctions) },
          { name: 'Bids', number: Number(data.bids) },
          { name: 'Clears', number: Number(data.clears) }
        ]
      }
    },
  },
  components: {
    StatsBar,
    ReportTable,
    FunnelGraph,
    ReportTimeStatGraphs,
    SessionValueSplineGraph,
    SessionDepthStackedBarGraph,
    NoResults
  }
}
</script>



// WEBPACK FOOTER //
// src/reports/components/User/UserOverview.vue